module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.article) ? _c('div', [(!_vm.$store.state.isEnhanced) ? _c('article-detail-component', [_c('div', {
    staticClass: "keywords",
    attrs: {
      "slot": "keywords"
    },
    slot: "keywords"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        Keywords:\n      ")]), _vm._v(" "), _c('div', {}, _vm._l((_vm.article.keywords), function(keyword) {
    return _c('div', {
      staticClass: "link"
    }, [_vm._v(_vm._s(keyword))])
  }))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.article.title))]), _vm._v(" "), _c('issue-authors', {
    attrs: {
      "authors": _vm.article.authors
    }
  })], 1), _vm._v(" "), _c('sidebar-article-section', {
    attrs: {
      "slot": "bar",
      "article": _vm.article
    },
    slot: "bar"
  })], 1) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b', [_vm._v("Alt Metric")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('b', [_vm._v("29,876")]), _vm._v(" Score")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "img h2"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b', [_vm._v("Views:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('b', [_vm._v("29,876")]), _vm._v(" Total Views")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "img h1"
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b', [_vm._v("Citations:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('b', [_vm._v("29,876")]), _vm._v(" Total Citations")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "img h1"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b', [_vm._v("Mentions")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('b', [_vm._v("29,876")]), _vm._v(" Total Mentions")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "btn active"
  }, [_vm._v("News (123)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "btn btn-default"
  }, [_vm._v("Scientific Blogs (123)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "btn btn-default"
  }, [_vm._v("Google+ (123)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "btn btn-default"
  }, [_vm._v("Citations (123)")])])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b', [_vm._v("Social Attention:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('b', [_vm._v("29,876")]), _vm._v(" Total Shares")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "img h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "img h1"
  }), _vm._v(" "), _c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-9"
  }, [_c('div', {
    staticClass: "img h3"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29a331e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/publications/article-detail/MetricsPage.vue
// module id = 1410
// module chunks = 1